import { render, staticRenderFns } from "./DocumentValidationModal.vue?vue&type=template&id=3ba52d8e&scoped=true"
import script from "./DocumentValidationModal.vue?vue&type=script&lang=ts"
export * from "./DocumentValidationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba52d8e",
  null
  
)

export default component.exports